import { usePageConfigProviderContext } from "src/features/PageConfigProvider";
import { usePermission, useTranslation } from "src/hooks";
import { FeatureCodes } from "src/utils/constant";
import { useGenGridCol } from "src/utils/HelperComp";
import useCopyableCell from "./useCopyableCell";
import useOperationCell from "./useOperationCell";
import { TableColumnKey } from "../types/Table";

const useTableColumns = () => {
  const { translatePrefix } = usePageConfigProviderContext();
  const { t } = useTranslation(translatePrefix);
  const { hasPermission } = usePermission();

  const { renderOperationCell, renderDialogInOperationCell } =
    useOperationCell();
  const { renderCopyableCell } = useCopyableCell();

  const renderDialogInTableRow = () => {
    return <>{renderDialogInOperationCell()}</>;
  };

  const columns = [
    useGenGridCol(TableColumnKey.Operation, t(TableColumnKey.Operation), {
      renderCell: renderOperationCell,
      minWidth: 120,
    }),
    useGenGridCol(TableColumnKey.ChainName, t(TableColumnKey.ChainName)),
    useGenGridCol(TableColumnKey.Currency, t(TableColumnKey.Currency)),
    useGenGridCol(TableColumnKey.RiskType, t(TableColumnKey.RiskType)),
    useGenGridCol(TableColumnKey.Status, t(TableColumnKey.Status)),
    useGenGridCol(TableColumnKey.GroupName, t(TableColumnKey.GroupName), {
      minWidth: 170,
    }),
    useGenGridCol(
      TableColumnKey.WalletDisplayName,
      t(TableColumnKey.WalletDisplayName),
      { minWidth: 300 },
    ),
    useGenGridCol(
      TableColumnKey.RecipientAddress,
      t(TableColumnKey.RecipientAddress),
      {
        renderCell: renderCopyableCell("recipientAddress"),
        minWidth: 300,
      },
    ),
    useGenGridCol(TableColumnKey.WalletType, t(TableColumnKey.WalletType), {
      minWidth: 180,
    }),
    useGenGridCol(TableColumnKey.Rating, t(TableColumnKey.Rating)),
    useGenGridCol(TableColumnKey.CreatedBy, t(TableColumnKey.CreatedBy)),
    useGenGridCol(TableColumnKey.CreationTime, t(TableColumnKey.CreationTime), {
      minWidth: 150,
    }),
    useGenGridCol(
      TableColumnKey.LastModifiedTime,
      t(TableColumnKey.LastModifiedTime),
      { minWidth: 150 },
    ),
  ].filter((col) => {
    if (
      col.field === TableColumnKey.Operation &&
      !hasPermission(
        FeatureCodes.assetManagement.ContractSweepRecipentSetting
          .ContractSweepRecipent.viewGroup,
      )
    ) {
      return false;
    }
    return true;
  });
  return { columns, renderDialogInTableRow };
};

export default useTableColumns;
